<script lang="ts" setup>
import { QuizURL } from '@ts-types/quiz/url/enums'
// assets
import logo from '@images/404.svg'
// components
import BtnSubmit from '@UI/Buttons/BtnSubmit.vue'
import TextPrimary from '@UI/Typography/TextPrimary.vue'

defineOptions({
  name: 'PageNotFound'
})

const setRedirect = async (): Promise<void> => {
  const path = `/${QuizURL.Quiz15}`
  await navigateTo({ path })
}
</script>

<template>
  <div class="err">
    <div class="err__inner">
      <div class="err__head">
        <img
            :src="logo"
            alt="404.svg"
        >
      </div>
      <div class="err__content">
        <div class="err__info">
          <h4 class="err__title">
            Oops...Something went wrong 👀
          </h4>
          <TextPrimary class="err__text">
            Accidents happen, but feel free to go back and try again
          </TextPrimary>
        </div>
        <BtnSubmit
            text="Back to home"
            @click="setRedirect"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="@scss/pages/error.scss" />
